import { render, staticRenderFns } from "./StatusUpdateModal.vue?vue&type=template&id=d547d674"
import script from "./StatusUpdateModal.vue?vue&type=script&lang=js"
export * from "./StatusUpdateModal.vue?vue&type=script&lang=js"
import style0 from "./StatusUpdateModal.vue?vue&type=style&index=0&id=d547d674&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports